import Schema from 'AppReact/schema';
import { today } from 'AppReact';

export default {
  isVisible: Schema('boolean', 'primitive', { defaultValue: false }),
  openCalendar: Schema('boolean', 'primitive', { defaultValue: false }),
  startDate: Schema('jsDate', 'primitive-nullable', { defaultValue: null }),
  endDate: Schema('jsDate', 'primitive-nullable', { defaultValue: null }),
  selectedTimeSpan: Schema('string', 'primitive-nullable', { defaultValue: null }),
  editingDate: Schema('string', 'primitive-nullable', { defaultValue: null }),
  selectedYear: Schema('integer', 'primitive', { defaultValue: today().getFullYear() }),
}